<template>
  <input
    :class="['input-field', { 'is-hidden': isHidden }, { selected, untitled }]"
    data-external="name-input"
    v-bind="$attrs"
    spellcheck="false"
  />
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isHidden: {
      type: Boolean,
    },
    selected: {
      type: Boolean,
    },
    untitled: {
      type: Boolean,
    },
  },
});
</script>

<style lang="scss" scoped>
@import './scss/inline-input';
</style>
